import React from 'react'
import { Flex } from '@sendoutcards/quantum-design-ui'

import { useCallback } from 'src/hooks'
import { CommunicationPreferences } from 'src/dashboard/components'
import { useUpdateAccountSettings } from 'src/react_query'
import { AccountSettingsInput } from 'src/graphql/generated/graphql'

type DashboardSettingsProps = {
  onToggleAccountDrawer: () => void
}

export const DashboardSettings: React.FC<DashboardSettingsProps> = ({
  onToggleAccountDrawer,
}) => {
  const updateAccountSettingsMutation = useUpdateAccountSettings()
  const handleUpdateSetting = useCallback(
    async <
      SettingName extends keyof Omit<
        AccountSettingsInput,
        'defaultBackPanelId'
      >,
    >(
      settingName: SettingName,
      value: boolean | number,
    ) => {
      updateAccountSettingsMutation.mutate({
        [settingName]: value,
      })
    },
    [updateAccountSettingsMutation],
  )

  return (
    <Flex
      style={{
        width: '100%',
        maxWidth: '1420px',
        margin: '0 auto',
        padding: '0 16px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
        gap: '24px',
        alignItems: 'start',
      }}
    >
      <Flex flexDirection="column">
        <CommunicationPreferences onToggle={handleUpdateSetting} />
      </Flex>
    </Flex>
  )
}
